import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import Modalheader from '../../../components/header';
import { useState } from 'react';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import ApiDatabase from '../../../../../server';
import Button from '../../../../button';
import { toast } from 'react-toastify';

const ModalPayslipImportGlobal = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const token = localStorage.getItem('xsrfToken');

  const payslips = modalData?.payslips || [];
  const year = modalData?.year || '';
  const month = modalData?.month || '';
  const preSelected = modalData?.preSelected || false;

  const toImportIds = payslips
    .filter((p) => p.status === 'not_imported')
    .map((p) => p.id_temp_worker_bestt);

  const allIds = payslips.map((p) => p.id_temp_worker_bestt);

  const [filter, setFilter] = useState(preSelected ? 'all' : 'to_import');
  const [selectedIds, setSelectedIds] = useState(preSelected ? allIds : toImportIds);
  const [sendNotifications, setSendNotifications] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const allSelected =
    selectedIds.length === payslips.length && payslips.length > 0;

  const handleFilterAll = () => {
    setFilter('all');
    setSelectedIds(payslips.map((p) => p.id_temp_worker_bestt));
  };

  const handleFilterToImport = () => {
    setFilter('to_import');
    setSelectedIds(toImportIds);
  };

  const handleToggleAll = () => {
    setSelectedIds(
      allSelected ? [] : payslips.map((p) => p.id_temp_worker_bestt)
    );
  };

  const handleToggleOne = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleConfirm = () => {
    if (selectedIds.length === 0) return;
    setIsLoading(true);

    ApiDatabase.importPayslips(
      {
        token,
        year,
        month,
        paid: true,
        id_temp_worker_bestt: selectedIds,
        sendNotifications,
      },
      (data) => {
        setIsLoading(false);
        toast.success(
          `Import lancé pour ${selectedIds.length} fiche(s) de paie.`
        );
        setModalDataReturn({
          action: 'payslips_imported',
          id_temp_worker_bestt: selectedIds,
          year,
          month,
        });
        toggle();
      },
      (err) => {
        setIsLoading(false);
        toast.error(err.response?.data?.error || 'Une erreur est survenue.');
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Import global - Fiches de paie {year}/{month}
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-4 text-sm">
          <div>
            <strong>{payslips.length}</strong> intérimaire(s) concerné(s) -{' '}
            <strong>{selectedIds.length}</strong> sélectionné(s)
          </div>

          {!preSelected && (
            <div className="flex gap-2">
              <button
                className={`px-3 py-1.5 rounded-lg border text-sm font-medium transition-colors ${
                  filter === 'to_import'
                    ? 'bg-yellow-500 text-white'
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-yellow-50'
                }`}
                onClick={handleFilterToImport}
              >
                À importer ({toImportIds.length})
              </button>
              <button
                className={`px-3 py-1.5 rounded-lg border text-sm font-medium transition-colors ${
                  filter === 'all'
                    ? 'bg-yellow-500 text-white'
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-yellow-50'
                }`}
                onClick={handleFilterAll}
              >
                Tous ({payslips.length})
              </button>
            </div>
          )}

          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox" className="checkbox-primary"
              checked={sendNotifications}
              onChange={() => setSendNotifications(!sendNotifications)}
            />
            Notifier les utilisateurs
          </label>

          <div className="max-h-[400px] overflow-y-auto border rounded">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 sticky top-0">
                <tr>
                  <th className="p-2 text-left">
                    <input
                      type="checkbox" className="checkbox-primary"
                      checked={allSelected}
                      onChange={handleToggleAll}
                    />
                  </th>
                  <th className="p-2 text-left">ID BeSTT</th>
                  <th className="p-2 text-left">Nom / Prénom</th>
                  <th className="p-2 text-right">Montant</th>
                  <th className="p-2 text-left">Statut</th>
                </tr>
              </thead>
              <tbody>
                {payslips.map((p) => (
                  <tr
                    key={p.id_temp_worker_bestt}
                    className="border-t border-gray-100 hover:bg-gray-50"
                  >
                    <td className="p-2">
                      <input
                        type="checkbox" className="checkbox-primary"
                        checked={selectedIds.includes(p.id_temp_worker_bestt)}
                        onChange={() => handleToggleOne(p.id_temp_worker_bestt)}
                      />
                    </td>
                    <td className="p-2">{p.id_temp_worker_bestt}</td>
                    <td className="p-2">
                      {p.lastname} {p.firstname}
                    </td>
                    <td className="p-2 text-right">
                      {p.amount ? `${Number(p.amount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €` : '-'}
                    </td>
                    <td className="p-2">
                      {p.status === 'imported' ? (
                        <span className="text-green-700 bg-green-100 px-2 py-0.5 rounded text-xs">
                          Importé
                        </span>
                      ) : (
                        <span className="text-gray-700 bg-gray-100 px-2 py-0.5 rounded text-xs">
                          Non importé
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        {isLoading ? (
          <div className="flex gap-2">
            <Button size="LG" color="DISABLED">
              Annuler
            </Button>
            <Button size="LG" color="DISABLED">
              Confirmer ...
            </Button>
          </div>
        ) : (
          <div className="flex gap-2">
            <Button onClick={toggle} size="LG" color="SECONDARY">
              Annuler
            </Button>
            <Button
              onClick={handleConfirm}
              size="LG"
              disabled={selectedIds.length === 0}
            >
              Confirmer ({selectedIds.length})
            </Button>
          </div>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalPayslipImportGlobal;
